import apiFetch from '../../../utils/fetch';
import {API_HOST, API_PATH} from '../../../config/_entrypoint';
import jwt from 'jsonwebtoken';

import {
    USER_AUTH_HIDE,
    USER_AUTH_LOGGED,
    USER_AUTH_LOGIN,
    USER_AUTH_LOGOUT,
    USER_AUTH_SHOW,
    USER_GET_MIN_REMAINING_QUESTIONS,
    USER_REFRESH_TOKEN,
    USER_SET_DATA
} from './mutation-types';
import {
    CURRENT_USER,
    GET_MIN_REMAINING_QUESTIONS,
    LOGIN,
    LOGOUT,
    TOKEN_REFRESH
} from '../../../constants/api-routes';


function getDefaultLocale() {
    switch (navigator.language) {
        case 'fr-FR':
        case 'fr':
            return 'fr_FR';
        default:
            return 'en_US';
    }
}

function removeToken() {
    localStorage.removeItem('user-token');
    localStorage.removeItem('refresh-token');
    localStorage.removeItem('user-data');
}

/** Store **/
const getDefaultState = () => {
    return {
        loginFormVisible: false,
        loginRequired: false,
        token: null,
        refreshToken: null,
        userData: null,
        minRemainingQuestions: null,
    };
};
const state = {
    ...getDefaultState(),
    ...{
        token: localStorage.getItem('user-token') || null,
        refreshToken: localStorage.getItem('refresh-token') || null,
        userData: localStorage.getItem('user-data') ? JSON.parse(localStorage.getItem('user-data')) : null,
    }
};

const getters = {
    logged: state => state.token !== null,
    token: state => state.token,
    refreshToken: state => state.refreshToken,
    userData: state => state.userData ? state.userData : {'email': ''},
    loginFormVisible: state => state.loginFormVisible,
    loginRequired: state => state.loginRequired,
    locale: state => (state.userData && state.userData.language ? state.userData.language : getDefaultLocale()),
    minRemainingQuestions: state => state.minRemainingQuestions,
};

function setUserData(data) {
    return {type: USER_SET_DATA, data};
}

function login() {
    return {type: USER_AUTH_LOGIN};
}

function logged(data) {
    return {type: USER_AUTH_LOGGED, data};
}

function logout() {
    return {type: USER_AUTH_LOGOUT};
}

function showModal(required) {
    return {type: USER_AUTH_SHOW, required};
}

function hideModal() {
    return {type: USER_AUTH_HIDE};
}

function refreshToken(token) {
    return {type: USER_REFRESH_TOKEN, token};
}

function getMinRemainingQuestions(data) {
    return {type: USER_GET_MIN_REMAINING_QUESTIONS, data};
}

const actions = {
    async logged({commit}, data) {
        commit(logged(data));
    },
    async getCurrent({commit}) {
        return apiFetch(CURRENT_USER)
            .then((data) => {
                commit(setUserData(data));
            });
    },
    async hideModal({commit}) {
        commit(hideModal());
    },
    async showModal({commit}) {
        commit(showModal());
    },
    async login({commit, dispatch}, user) {
        commit(login());
        return apiFetch(LOGIN, {method: 'POST', data: user})
            .then((data) => {
                commit(logged(data));
                dispatch('hideModal');
                dispatch('getCurrent');
            });
    },
    async logout({commit, state}) {
        if (state.logged) {
            apiFetch(LOGOUT, {method: 'POST', data: {refreshToken: state.refreshToken}});
        }
        commit(logout());
    },
    async requireLogin({commit}, required = false) {
        commit(logout());
        commit(showModal(required));
    },
    async refreshToken({commit, state, rootState, dispatch}) {
        let decodedToken = jwt.decode(state.token);
        if (decodedToken && decodedToken.exp > (Math.floor(Date.now() / 1000)) + 5) {
            return;
        }
        if (rootState.user.facebookAuth.facebookToken !== null) {
            return await dispatch('user/facebookAuth/login', rootState.user.facebookAuth.facebookToken, {root: true});
        }

        let response = await apiFetch(TOKEN_REFRESH, {
            method: 'POST',
            data: 'refresh_token=' + state.refreshToken,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }, true, false);

        if (response.status === 401) {
            return;
        }
        let {token} = await response;
        commit(refreshToken(token));
    },
    async getMinRemainingQuestions({commit}) {
        return apiFetch(GET_MIN_REMAINING_QUESTIONS)
            .then((data) => {
                commit(getMinRemainingQuestions(data));
            });
    },
};

const mutations = {
    [USER_AUTH_LOGIN]: state => {
        state.token = null;
        state.refreshToken = null;
        removeToken();
    },
    [USER_AUTH_LOGGED]: (state, payload) => {
        state.token = payload.data.token;
        state.refreshToken = payload.data.refresh_token || null;
        localStorage.setItem('user-token', state.token);
        localStorage.setItem('refresh-token', state.refreshToken);
    },
    [USER_AUTH_LOGOUT]: (state) => {
        Object.assign(state, getDefaultState());
        removeToken();
    },
    [USER_AUTH_SHOW]: (state, payload) => {
        state.loginFormVisible = true;
        state.loginRequired = payload.required;
    },
    [USER_AUTH_HIDE]: state => {
        state.loginFormVisible = false;
    },
    [USER_SET_DATA]: (state, payload) => {
        localStorage.setItem('user-data', JSON.stringify(payload.data));
        state.userData = payload.data;
    },
    [USER_REFRESH_TOKEN]: (state, payload) => {
        localStorage.setItem('user-token', payload.token);
        state.token = payload.token;
    },
    [USER_GET_MIN_REMAINING_QUESTIONS]: (state, payload) => {
        state.minRemainingQuestions = payload.data.min;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/user/auth.js